import { render, staticRenderFns } from "./SkeletonImg.vue?vue&type=template&id=47968e74&"
import script from "./SkeletonImg.vue?vue&type=script&lang=js&"
export * from "./SkeletonImg.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonImg.vue?vue&type=style&index=0&id=47968e74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports